import React from 'react';
import PropTypes from 'prop-types';
import { ReviewEntities } from 'client/data/models/dealer-reviews';
import {
  DEALER_PROPS,
  DEFAULT_REVIEWS_TYPE,
  REVIEWS_SALES,
  REVIEWS_SERVICE,
  REVIEWS_ALL,
} from 'client/constants/dealer-reviews';
import { DealerReviewsOverallRating } from 'site-modules/dealerships/components/dealer-review-overall-rating/dealer-review-overall-rating';
import { DealerReviewsList } from 'site-modules/dealerships/components/dealer-reviews-list/dealer-reviews-list';
import { UserReview } from 'site-modules/dealerships/components/user-review/user-review';
import { WriteAReviewLink } from 'site-modules/shared/components/write-review-link/write-review-link';

import './dealer-review-good-view.scss';

export function DealerReviewGoodView(props) {
  const {
    overallData,
    featuredReview,
    reviewsType,
    writeReviewLink,
    readReviewsLink,
    params,
    showroomPage,
    isMobile,
  } = props;

  // rating will be 0 if there are no reviews from the last two years, should not display it
  const isDisplayOverallRating = !!overallData.averageRating;

  return (
    <div className="dealer-review-good-view">
      <div className="featured-info d-flex justify-content-center flex-column flex-md-row mb-1 mb-md-2">
        {isDisplayOverallRating && (
          <DealerReviewsOverallRating
            rating={overallData}
            reviewsType={reviewsType}
            readReviewsLink={readReviewsLink}
            writeReviewLink={writeReviewLink}
          />
        )}
        {featuredReview && (
          <div>
            <UserReview review={featuredReview} params={params} />
            {isMobile && <hr className="mt-1_5 mb-0" />}
          </div>
        )}
      </div>
      <div>
        <DealerReviewsList
          reviewsType={reviewsType}
          totalReviews={overallData.totalCount}
          params={params}
          isMobile={isMobile}
        />
        <div className="d-flex align-items-start justify-content-md-center write-review-links flex-column flex-md-row">
          {reviewsType === REVIEWS_ALL && (
            <>
              <WriteAReviewLink params={params} reviewsType={REVIEWS_SALES} showroomPage={showroomPage} noFollow />
              <WriteAReviewLink params={params} reviewsType={REVIEWS_SERVICE} showroomPage={showroomPage} noFollow />
            </>
          )}
          {reviewsType !== REVIEWS_ALL && (
            <WriteAReviewLink params={params} reviewsType={reviewsType} showroomPage={showroomPage} noFollow />
          )}
        </div>
      </div>
    </div>
  );
}

DealerReviewGoodView.propTypes = {
  overallData: ReviewEntities.OverallRatingEntity,
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string,
  featuredReview: ReviewEntities.ReviewEntity,
  writeReviewLink: PropTypes.string.isRequired,
  readReviewsLink: PropTypes.string.isRequired,
  showroomPage: PropTypes.string,
  isMobile: PropTypes.bool,
};

DealerReviewGoodView.defaultProps = {
  overallData: {},
  reviewsType: DEFAULT_REVIEWS_TYPE,
  featuredReview: null,
  readReviewsLink: '',
  writeReviewLink: '',
  showroomPage: '',
  isMobile: false,
};
